<template>
  <section>
    <div class="d-flex justify-content-center">
      <div class="cards ativo" @click="selectedFilter('ativo')">
        <h4> Ativos </h4>
        <hr class="style-two">
        <h5>{{ active }}</h5>
      </div>

      <div class="cards disponivel" @click="selectedFilter('disponivel')">
        <h4> Disponíveis </h4>
        <hr class="style-two">
        <h5>{{ available }}</h5>
      </div>

      <div class="cards ligacao" @click="selectedFilter('ligacao')">
        <h4> Em Ligação </h4>
        <hr class="style-two">
        <h5>{{ call }}</h5>
      </div>

      <div class="cards pausa" @click="selectedFilter('pausa')">
        <h4> Em Pausa </h4>
        <hr class="style-two">
        <h5>{{ pause }}</h5>
      </div>

      <div class="cards chat" @click="selectedFilter('chat')">
        <h4> Em Chat </h4>
        <hr class="style-two">
        <h5>{{ chat }}</h5>
      </div>

      <div class="cards deslogado" @click="selectedFilter('deslogado')">
        <h4> Deslogados </h4>
        <hr class="style-two">
        <h5>{{ logoff }}</h5>
      </div>
    </div>
  </section>
</template>

<script>
import { getStatus } from "./status";

const hideall = function () {
  let divs = document.querySelectorAll('.card-realtime:not([type="none"])');

  [].forEach.call(divs, function (div) {
    div.closest("section").style.display = "none";
  });
};

const showCall = function (type) {
  filterCards(type);
  return setInterval(() => {
    filterCards(type);
  }, 1000);
};

const filterCards = function (type) {
  hideall();
  let divs = document.querySelectorAll(`div.linha-status.${type}`);
  [].forEach.call(divs, function (div) {
    div.closest("section").style.display = "";
  });
};

export default {
  data: function () {
    return {
      call: 0,
      pause: 0,
      active: 0,
      logoff: 0,
      chat: 0,
      todos: 0,
      available: 0,
      intervalor: {},
    };
  },
  methods: {
    selectedFilter(filter) {
      setCookie("realtimeSettings", filter, "filter");
      document.getElementById("searchramal");
      clearInterval(this.intervalor);
      if (filter == "ativo") {
        filter = "ativo, div.linha-status.pausa, div.linha-status.ligacao, div.linha-status.chat";
      } else if (filter == "disponivel") {
        filter = "ativo";
      }

      this.intervalor = showCall(filter);
    },
    setFilter() {
      const cookieFilter = getCookie("realtimeSettings", "filter");
      if (cookieFilter && cookieFilter != "all") {
        this.selectedFilter(cookieFilter);
      };
    },
    updateCards() {
      const { ligacao, pausa, deslogado, ativo, chat } = getStatus();
      this.call = ligacao;
      this.pause = pausa;
      this.active = ligacao + pausa + ativo + chat;
      this.logoff = deslogado;
      this.available = ativo;
      this.chat = chat;
      this.todos = ligacao + pausa + ativo + deslogado + chat;
    }
  },
  mounted() {
    this.setFilter();
    setInterval(() => {
      this.updateCards();
    }, 100);

    const self = this;
    if (document.getElementById("searchramal") != null) {
      document
        .getElementById("searchramal")
        .addEventListener("keydown", function (e) {
          clearInterval(self.intervalor);
        });
    }
  },
};
</script>

<style scoped>
.cards {
  border-radius: 4px;
  align-content: center;
  color: white;
  height: 7em;
  width: 11em;
  text-align: center;
  margin-right: 1em;
  padding: 0.5em;
  margin-bottom: 2em;
  cursor: pointer;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  transition: all 0.3s cubic-bezier(.25, .8, .25, 1);
}

.cards:hover {
  box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
}

.ligacao {
  background-color: #16a085;
}

.pausa {
  background-color: #f39c12;
}

.ativo {
  background-color: #17a2b8;

}

.deslogado {
  background-color: #a1a1a1;
}

.disponivel {
  background-color: #9d4edd;
}

.chat {
  background-color: #fb6107;
}

.todos {
  background-color: #a1a1a1;
}

hr.style-two {
  margin-top: 0px;
  border: 0;
  height: 1px;
  background-image: linear-gradient(to right, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.75), rgba(255, 255, 255, 0));
}
</style>